import { render } from "./PackagePage.vue?vue&type=template&id=68231414&scoped=true"
import script from "./PackagePage.vue?vue&type=script&lang=js"
export * from "./PackagePage.vue?vue&type=script&lang=js"

import "./PackagePage.vue?vue&type=style&index=0&id=68231414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68231414"]])

export default __exports__